import type { DocumentHistoryEntry } from '../../lib/api/documents';
import Changelog, { ChangelogEntry } from '../../components/common/Changelog';
import { Loader2 } from 'lucide-react';

interface DocumentHistoryTabProps {
  history: DocumentHistoryEntry[];
  loading: boolean;
  error: string | null;
  /** Shown when there is no history. CR-7754: the folder window reuses this tab. */
  emptyMessage?: string;
}

/** Audit History tab body of DocumentDetailModal (and FolderDetailsDialog), driven by the shared Changelog component. */
export default function DocumentHistoryTab({
  history,
  loading,
  error,
  emptyMessage = 'No activity recorded for this document yet.',
}: DocumentHistoryTabProps) {
  // Synthetic backend ids ('upload-12', 'download-44') are useful in the
  // network tab but Changelog types ChangelogEntry.id as number. Map them
  // to the array index for the React key — the component only uses id as
  // a key.
  const changelogEntries: ChangelogEntry[] = history.map((e, idx) => ({
    id: idx + 1,
    change_date: e.change_date,
    changed_by: e.changed_by,
    changed_by_company: e.changed_by_company || undefined,
    field_changed: e.field_changed,
    old_value: e.old_value,
    new_value: e.new_value,
    event_type: e.event_type,
  }));

  return loading ? (
    <div className="flex items-center justify-center py-12 text-muted-foreground">
      <Loader2 className="h-5 w-5 animate-spin mr-2" />
      Loading history...
    </div>
  ) : error ? (
    <div className="text-center py-8 text-muted-foreground">{error}</div>
  ) : (
    <Changelog
      entries={changelogEntries}
      emptyMessage={emptyMessage}
    />
  );
}
